import { H3 } from '@h3/types';
import { request } from '@h3/request';

/** 获取关联表单配置 */
export const getAssociationListDesignSetting = (params: { schemaCode: string }) =>
    request<H3.Http.Response.H3Response<H3.Form.FormSetting.Response.IAssociationDesignSetting>>(
        '/v1/associationlist/design/setting',
        {
            method: H3.Http.MethodType.GET,
            params,
        },
    );

/** 保存关联表单配置(单条) */
export const saveAssociationListDesignSetting = (params: H3.Form.FormSetting.Request.IAssociationDesignSetting) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/associationlist/design/setting', {
        method: H3.Http.MethodType.POST,
        data: params,
    });

/** 保存关联表单配置(排序) */
export const sortAssociationListDesignSetting = (params: { schemaCode: string; associationSchemaCodes: string[] }) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/associationlist/design/sort', {
        method: H3.Http.MethodType.POST,
        data: params,
    });

/** 获取配置显示字段 */
export const getAssociationListDesignFields = (params: { schemaCode: string; associationSchemaCode: string }) =>
    request<
        H3.Http.Response.H3Response<{
            isDefault: boolean;
            fieldMap: Record<string, string>;
            fields: Array<{ code: string; visible: boolean }>;
        }>
    >('/v1/associationlist/design/fields', {
        method: H3.Http.MethodType.GET,
        params,
    });

/** 保存配置显示字段 */
export const saveAssociationListDesignFields = (params: {
    schemaCode: string;
    associationSchemaCode: string;
    displayType: 0 | 1;
    viewPageId?: string | null;
    fields: Array<{ code: string; visible: boolean }>;
}) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/associationlist/design/display', {
        method: H3.Http.MethodType.POST,
        data: params,
    });
